<template>
  <v-container fluid class="webdialer-container pa-0">
    <!-- Modern Header -->
    <div v-if="showHeader" class="header-section mb-6">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-phone-classic</v-icon>
        </div>
        <div class="flex-grow-1">
          <h1 class="page-title mb-1">Web Dialer</h1>
          <p class="page-subtitle mb-0">Dial from your desktop - BETA</p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            class="mr-2 white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-phone</v-icon>
            Browser Calling
          </v-chip>
          <v-chip
            class="white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-desktop-classic</v-icon>
            Desktop Integration
          </v-chip>
        </div>
      </div>
    </div>

    <!-- Info Card -->
    <v-row class="ma-0 px-3 mb-4">
      <v-col cols="12">
        <v-card class="modern-card customBorderRadius" elevation="0">
          <div class="card-header">
            <div class="d-flex align-center">
              <div class="icon-badge mr-3">
                <v-icon color="#FFFFFF">mdi-information</v-icon>
              </div>
              <div>
                <h3 class="card-title mb-0">How It Works</h3>
                <p class="card-subtitle mb-0">Launch calls from your browser</p>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <p class="mb-0">
              Launch calls from your browser using Skype for Business, GoDial
              Telecmi Cloud Calling or any Calling app which can become default
              call handler for your computer.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialer Component -->
    <v-row class="ma-0 px-3 pb-6 mb-6">
      <v-col cols="12" class="text-center">
        <v-card class="modern-card customBorderRadius" elevation="0">
          <v-card-text class="pa-6">
            <Dialer ref="dialer" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Dialer from "../components/dialer.vue";
export default {
  components: { Dialer },
  data() {
    return {
      showHeader: false,
    };
  },
  created() {
    this.showHeader =
      localStorage.getItem("webDialerHeaderDismissed") !== "true";
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("webDialerHeaderDismissed", "true");
    },
  },
};
</script>

<style scoped>
.webdialer-container {
  background-color: var(--v-background-base, #ffffff);
  min-height: 100vh;
  padding-bottom: 24px;
}

.theme--dark .webdialer-container {
  background-color: #121212 !important;
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 32px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.modern-card {
  background: white;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  height: auto;
}

.modern-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.customBorderRadius {
  border-radius: 12px !important;
  overflow: visible !important;
}

.card-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
}

.icon-badge {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.card-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

@media (max-width: 960px) {
  .header-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .page-title {
    font-size: 28px;
  }
}
</style>
